/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // PDP gallery: the theme only preloads the next/previous image when a mouse hovers an arrow, which never
  // happens on touch screens, so every tap waited for a lazy image to load. Load the neighbours of the
  // visible slide eagerly instead.
  function preloadNeighbourSlides(list) {
    const slides = Array.from(list.querySelectorAll('[data-image-id]'));
    const current = slides.findIndex((slide) => slide.classList.contains('media--active'));
    if (current === -1) return;

    [current - 1, current + 1].forEach((index) => {
      const slide = slides[(index + slides.length) % slides.length];
      slide && slide.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));
    });
  }

  document.querySelectorAll('[data-product-media-list]').forEach((list) => {
    preloadNeighbourSlides(list);
    new MutationObserver(() => preloadNeighbourSlides(list)).observe(list, {subtree: true, attributeFilter: ['class']});
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
